import React, { ReactNode, useCallback, useEffect, useState } from "react";
import {
  Divider,
  Typography,
  TableContainer,
  Table as MuiTable,
  TableHead as MuiTableHead,
  TableRow,
  TableCell,
  Box,
  styled,
  TableBody
} from "@mui/material";

interface THeader {
  label: string;
  key: string;
}

const RowItem = styled(TableRow)({
  cursor: "pointer",
  ":hover": {
    backgroundColor: "#F6F6F6"
  }
});

export type TRow = { [key in string]: string | number };

const SelectableTable = ({
  headers,
  rows = [],
  emptyRowMessage,
  onRowSelect,
  checkId = ""
}: {
  headers: THeader[];
  rows: TRow[];
  emptyRowMessage?: ReactNode;
  onRowSelect: (item?: TRow) => void;
  checkId?: string;
}) => {
  const [selectedRow, setSelectedRow] = useState<TRow>();

  const handleClickRow = useCallback((row: TRow) => {
    setSelectedRow(curr => {
      if (curr?.[checkId] === row[checkId]) {
        return undefined;
      }
      return row;
    });
  }, [checkId]);

  useEffect(() => {
    onRowSelect(selectedRow);
  }, [selectedRow, onRowSelect]);

  return (
    <Box>
      <Divider />
      <TableContainer>
        <MuiTable
          aria-label="custom pagination table"
          sx={{
            whiteSpace: "nowrap"
          }}
        >
          <MuiTableHead>
            <TableRow>
              {headers.map((header, idx) => (
                <TableCell key={idx} style={{ textAlign: "center" }}>
                  <Typography variant="h6">{header.label}</Typography>
                </TableCell>
              ))}
            </TableRow>
          </MuiTableHead>

          <TableBody>
            {rows.length < 1 ? (
              <TableRow>
                <TableCell colSpan={headers.length} align="center">
                  {emptyRowMessage || "내용이 없습니다."}
                </TableCell>
              </TableRow>
            ) : (
              <>
                {rows.map((row, row_idx) => (
                  <RowItem key={row_idx} onClick={() => handleClickRow(row)}>
                    {headers.map((item, item_idx) => (
                      <TableCell
                        key={item_idx}
                        align="center"
                        sx={{
                          ...(selectedRow?.[checkId] === row[checkId] && {
                            backgroundColor: "#FAF4C0"
                          })
                        }}
                      >
                        <Typography variant="subtitle2">
                          {row[item.key]}
                        </Typography>
                      </TableCell>
                    ))}
                  </RowItem>
                ))}
              </>
            )}
          </TableBody>
        </MuiTable>
      </TableContainer>
    </Box>
  );
};

export default SelectableTable;
